var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowForwardUpRightSemibold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2733 15.2121C17.2733 15.6264 17.6091 15.9621 18.0233 15.9621C18.4375 15.9621 18.7733 15.6264 18.7733 15.2121L18.7733 7.01975C18.7733 6.05326 17.9898 5.26975 17.0233 5.26975L8.83095 5.26975C8.41673 5.26975 8.08095 5.60554 8.08095 6.01975C8.08095 6.43397 8.41673 6.76975 8.83095 6.76975L16.2127 6.76975L5.82574 17.1567C5.53285 17.4496 5.53285 17.9245 5.82574 18.2173C6.11864 18.5102 6.59351 18.5102 6.8864 18.2173L17.2733 7.83041L17.2733 15.2121Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardUpRightSemibold);
export default __webpack_public_path__ + "static/media/arrow_forward_up_right-semibold.102e6244a39742d24ed8ef9915077dd0.svg";
export { ForwardRef as ReactComponent };